'use client';

import { AppRouterCacheProvider } from '@mui/material-nextjs/v13-appRouter';
import { ThemeProvider } from '@mui/material/styles';

import theme from '@/styles/themes';
import ErrorPage from '@/views/ErrorPage';

export default function Error() {
  return (
    <AppRouterCacheProvider>
      <ThemeProvider theme={theme}>
        <ErrorPage />
      </ThemeProvider>
    </AppRouterCacheProvider>
  );
}
